import { render } from "./FreeSaleList.vue?vue&type=template&id=76335292"
import script from "./FreeSaleList.vue?vue&type=script&lang=js"
export * from "./FreeSaleList.vue?vue&type=script&lang=js"

import exportComponent from "/builds/infinitesoftsolutions/haz/haz-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__